// Role mascots for the Genie Templates catalogue (jobs-to-be-done).
//
// Each role mascot is generated by scripts/generate-role-mascots.mjs
// (Nano Banana Pro with reference-image anchoring). Files land in
// public/genie-mascots/role/<slug>.png.
//
// Until the real generated files land, this module falls back to existing
// numbered avatars at /genie-images/<n>.png so the catalogue renders something
// recognisably "genie-shaped" rather than a broken image. The fallback flag
// flips to false once the role-mascot generation run completes.

export type RoleSlug =
  | "onboarding"
  | "compliance"
  | "audit"
  | "survey"
  | "form"
  | "support"
  | "sales"
  | "marketing"
  | "after-hours"
  | "operations"
  | "receptionist"
  | "booking"
  | "quote"
  | "lead-capture"
  | "knowledge"
  | "returns"
  | "concierge"
  | "feedback";

const REAL_DIR = "/genie-mascots/role";

// Defensive fallbacks: if ROLE_MASCOTS_GENERATED ever flips to false (e.g.
// during a regeneration run), fall back to a known-good new mascot rather
// than the retired /genie-images/ library.
const ROLE_FALLBACKS: Record<RoleSlug, string> = {
  onboarding: `${REAL_DIR}/support.png`,
  compliance: `${REAL_DIR}/support.png`,
  audit: `${REAL_DIR}/support.png`,
  survey: `${REAL_DIR}/support.png`,
  form: `${REAL_DIR}/support.png`,
  support: `${REAL_DIR}/support.png`,
  sales: `${REAL_DIR}/support.png`,
  marketing: `${REAL_DIR}/support.png`,
  "after-hours": `${REAL_DIR}/support.png`,
  operations: `${REAL_DIR}/support.png`,
  receptionist: `${REAL_DIR}/support.png`,
  booking: `${REAL_DIR}/support.png`,
  quote: `${REAL_DIR}/support.png`,
  "lead-capture": `${REAL_DIR}/support.png`,
  knowledge: `${REAL_DIR}/support.png`,
  returns: `${REAL_DIR}/support.png`,
  concierge: `${REAL_DIR}/support.png`,
  feedback: `${REAL_DIR}/support.png`,
};

// Flip to true once scripts/generate-role-mascots.mjs has run and the PNGs
// land in public/genie-mascots/role/.
const ROLE_MASCOTS_GENERATED = true;

const roleMascotPath = (slug: RoleSlug): string =>
  ROLE_MASCOTS_GENERATED ? `${REAL_DIR}/${slug}.png` : ROLE_FALLBACKS[slug];

export const roleMascots: Record<RoleSlug, string> = {
  onboarding: roleMascotPath("onboarding"),
  compliance: roleMascotPath("compliance"),
  audit: roleMascotPath("audit"),
  survey: roleMascotPath("survey"),
  form: roleMascotPath("form"),
  support: roleMascotPath("support"),
  sales: roleMascotPath("sales"),
  marketing: roleMascotPath("marketing"),
  "after-hours": roleMascotPath("after-hours"),
  operations: roleMascotPath("operations"),
  receptionist: roleMascotPath("receptionist"),
  booking: roleMascotPath("booking"),
  quote: roleMascotPath("quote"),
  "lead-capture": roleMascotPath("lead-capture"),
  knowledge: roleMascotPath("knowledge"),
  returns: roleMascotPath("returns"),
  concierge: roleMascotPath("concierge"),
  feedback: roleMascotPath("feedback"),
};
